import { FilterElementType } from "@utils/DynamicComponentUtils";
import { forceUpdateCheck, textFormat, upDataAtFormat } from "@utils/TableItemFormattingUtils";
import { type ColDef } from "ag-grid-community";
import { type CommonFilterDataType, type CommonFormType } from "src/types/common";
import { type V2AppVersionsControllerFetchAppVersionsParams, V2AppVersionsControllerFetchAppVersionsPlatform as Platform } from "@everon-it/api-client/contents-gw";

export type AppVersionInitialValues = Pick<V2AppVersionsControllerFetchAppVersionsParams, "platform">;

export const appVersionData: CommonFilterDataType<AppVersionInitialValues, CommonFormType, ColDef> = {
    formInitialValues: {
        platform: undefined,
    },
    forms: [
        {
            type: FilterElementType.SELECT,
            name: "platform",
            label: "OS",
            option: [
                {
                    label: "전체",
                    value: "",
                },
                {
                    label: "IOS",
                    value: Platform.IOS,
                },
                {
                    label: "ANDROID",
                    value: Platform.ANDROID,
                },
            ],
        },
    ],
    tableList: [
        {
            field: "platform",
            headerName: "OS",
            maxWidth: 160,
            flex: 1,
            suppressMovable: true,
        },
        {
            field: "isForceUpdate",
            headerName: "강제 업데이트",
            maxWidth: 160,
            flex: 1,
            suppressMovable: true,
            cellRenderer: forceUpdateCheck,
        },
        {
            field: "versionName",
            headerName: "버전 정보",
            maxWidth: 160,
            flex: 1,
            suppressMovable: true,
        },
        {
            field: "releaseNotes",
            headerName: "릴리즈 노트",
            width: 750,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "updatedAt",
            headerName: "업데이트 일시",
            minWidth: 180,
            maxWidth: 200,
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
        {
            field: "updatedBy",
            headerName: "마지막 수정",
            pinned: "right",
            suppressMovable: true,
            maxWidth: 180,
            cellRenderer: textFormat,
        },
    ],
};
